/**
 * 安全地获取嵌套对象的属性
 * @param target 目标对象
 * @param key 对象的key值
 * @param defaultValue 没取到默认的值
 */
export const path = <O, T>(target: O, path: string, defaultValue: T) => {
  return (
    path.split('.').reduce((last, key) => (key && last && last[key] ? last[key] : undefined), target) || defaultValue
  )
}

interface Ilength {
  length: number
}
interface IReplace {
  replace: string
}
/**
 * 判断是否有值，0不发生转换，数字0和字符串0都是false，即 不为空
 * 空数组也返回true，即为空
 * @param v 需要检测的数据
 * @returns {boolean}
 */
export const isEmpty = <T extends Ilength | IReplace>(v: T): boolean => {
  switch (typeof v) {
    case 'undefined':
      return true
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
      break
    case 'boolean':
      if (!v) return true
      break
    case 'number':
      if (isNaN(v)) return true // 0不发生转换，数字0和字符串0都是false，即 不为空
      break
    case 'object':
      if (null === v) return true
      for (const i in v) {
        return false
      }
      return true
  }
  return false
}

export function getBase64(file: File | Blob, callback: Function, errorCallback?: Function) {
  if (file instanceof File || file instanceof Blob) {
    return new Promise((resolve, reject) => {
      Object.assign(new FileReader(), {
        onload({ target }) {
          callback && callback(target.result)
          resolve(target.result)
        },
        onerror(e) {
          errorCallback && errorCallback(e)
          reject(e)
        }
      }).readAsDataURL(file)
    })
  } else {
    callback && callback(file)
    return file
  }
}

export function getRawRoute(route: RouteLocationNormalized): RouteLocationNormalized {
  if (!route) return route
  const { matched, ...opt } = route
  return {
    ...opt,
    matched: (matched
      ? matched.map((item) => ({
          meta: item.meta,
          name: item.name,
          path: item.path
        }))
      : undefined) as RouteRecordNormalized[]
  }
}
